import { render } from "./App.vue?vue&type=template&id=699cc217"
const script = {}

import "./App.vue?vue&type=style&index=0&id=699cc217&lang=css"
script.render = render

export default script